module.exports = __webpack_public_path__ + "static/ally-CEFF-4ef19623dc6894b5d011916da900ba87.png";